import { parseDate } from '@bydesign-ui/utils';
import { wrapSyncFunc } from '../../util';
export var date = wrapSyncFunc(function (rule, value) {
  var format = rule.format,
      locale = rule.locale;

  if (format == null || typeof value !== 'string' || value === '') {
    return;
  }

  try {
    return parseDate(value, format, locale) != null;
  } catch (e) {
    return false;
  }
});